'use es6';

import enviro from 'enviro';
const PROD_KEY = 'prod';
const QA_KEY = 'qa';
const SHORT = enviro.getShort();
const IS_DEPLOYED = enviro.deployed();
const IS_PROD = SHORT === PROD_KEY;
const IS_QA = SHORT === QA_KEY;
const HUBLET = enviro.getHublet();
export { IS_DEPLOYED as isDeployed };
export { IS_PROD as isProd };
export { IS_QA as isQA };
export const hubletSuffix = HUBLET === 'na1' ? '' : `-${HUBLET}`;
export const domainSuffix = IS_QA ? QA_KEY : '';
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}